import { Space, Typography } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';
import React, { useState } from 'react';

import { VitrinsOffersCard } from 'shared/ui/VitrinsOffersCard';

import type { BankItem } from 'entities/vitrins';

import { CONTROL_CARD_BUTTON_TEXT } from 'features/VitrinsOffers/config';
import { useFetchVitrinsOffersData } from 'features/VitrinsOffers/lib';

import { ControlCardButton } from './ControlCardButton';

type Props = {
  isGrayCards?: boolean;
  submitButtonText?: string;
  onOfferSubmit?: (offer: BankItem) => Promise<void>;
};

export const VitrinsOffersCards: FC<Props> = (props) => {
  const { isGrayCards, submitButtonText, onOfferSubmit } = props;
  const offers = useFetchVitrinsOffersData();
  const isMobile = useIsMobile();
  const [isLoading, setIsLoading] = useState(false);

  if (!offers.length) {
    return null;
  }

  const goTo = async (item: BankItem) => {
    setIsLoading(true);
    await onOfferSubmit?.(item);
    setTimeout(() => setIsLoading(false), 300);
  };

  const modifySummary = (offer: BankItem) => offer.summary.filter((o) => (isMobile ? o.label : o));

  return (
    <Space
      direction="vertical"
      size={16}
    >
      {offers.map((offer) => (
        <VitrinsOffersCard
          isGrayCard={isGrayCards}
          key={offer.id + offer.subtitle}
          controls={[
            <ControlCardButton
              key={`button_${offer.id + offer.subtitle}`}
              onClick={() => goTo(offer)}
              isLoading={isLoading}
              buttonText={submitButtonText || CONTROL_CARD_BUTTON_TEXT.SEND_REQUEST}
            />,
          ]}
          {...offer}
          summary={modifySummary(offer)}
          title={<Typography.Heading level={5}>{offer.title}</Typography.Heading>}
        >
          {offer.otherOffers?.map((offerChild) => {
            return (
              <VitrinsOffersCard
                isGrayCard={isGrayCards}
                key={offerChild.id + offerChild.subtitle}
                controls={[
                  <ControlCardButton
                    isLoading={isLoading}
                    key={`button_${offerChild.id + offerChild.subtitle}`}
                    onClick={() => goTo(offerChild)}
                    buttonText={submitButtonText || CONTROL_CARD_BUTTON_TEXT.SEND_REQUEST}
                  />,
                ]}
                {...offerChild}
                summary={modifySummary(offerChild)}
                otherOffers={[]}
                title={<Typography.Heading level={5}>{offer.title}</Typography.Heading>}
              />
            );
          })}
        </VitrinsOffersCard>
      ))}
    </Space>
  );
};
